import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CommentsModule } from '../comments/comments.module';
import { DirectivesModule } from '../directives/directives.module';
import { RenewalsComponent } from './renewals/renewals.component';
import { RevenueRoutingModule } from './revenue-routing.module';
import { AmenityAveragesComponent } from './revenue/amenity-averages/amenity-averages.component';
import { RateSummaryComponent } from './revenue/rate-summary/rate-summary.component';
import { TotalComponent } from './revenue/total/total.component';
import { UnitTypesComponent } from './revenue/unit-types/unit-types.component';
import { RollupComponent } from './rollup/rollup.component';
import { RenewalFilterComponent } from './renewals/renewal-filter/renewal-filter.component';
import { ControlsModule } from '../controls/controls.module';
import { RevenueTotalComponent } from './revenue/total/revenue-total.component';
import { TccUiModule } from '../shared/tcc-ui/tcc-ui.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RevenueByBedCountComponent } from './revenueByBedCount/revenue-by-bed-count.component';
import { BedroomCountTypesComponent } from './revenueByBedCount/bedroom-count-type/bedroom-count-types.component';

@NgModule({
  declarations: [
    RenewalsComponent,
    RollupComponent,
    RevenueByBedCountComponent,
    AmenityAveragesComponent,
    UnitTypesComponent,
    RevenueTotalComponent,
    TotalComponent,
    RateSummaryComponent,
    RenewalFilterComponent,
    BedroomCountTypesComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    TccUiModule,
    ControlsModule,
    DirectivesModule,
    CommentsModule,
    RevenueRoutingModule,
    NgbDropdownModule,
    NgbTooltipModule,
    ReactiveFormsModule
  ]
})
export class RevenueModule { }
